import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const rick_and_morty_faq_data = [
    {
        question: "What is the Rick and Morty Filter, and how does it work?",
        answer: "The Rick and Morty Filter uses advanced AI to turn your photos into the chaotic, colorful art style from the famous sci-fi cartoon. It replicates the show’s distinct linework, color tones, and exaggerated expressions for that interdimensional vibe.",
    },
    {
        question:
            "Do I need any artistic skills to use the Rick and Morty Filter?",
        answer: "Not at all! The Rick and Morty Filter is completely automated. You just upload your photo, and the AI does the rest — adding the series’ signature bold outlines, shading, and surreal flair with one click.",
    },
    {
        question:
            "What kind of photos work best with the Rick and Morty Filter?",
        answer: "Portraits work best — whether solo or with friends. But you can also use it for pets, objects, or even landscapes to give everything that wacky Rick and Morty dimension-travel aesthetic.",
    },
    {
        question: "Are my photos private and secure?",
        answer: "Yes, your privacy is fully protected. Patternful.ai keeps your images secure and deletes them automatically after processing. Your creations remain entirely your property.",
    },
];

const rick_and_morty_use_cases = [
    {
        title: "Social Media Avatars",
        description:
            "Show off your interdimensional alter ego! Turn your selfies into Rick and Morty–style characters perfect for social profiles, streaming channels, or Discord avatars.",
        image: "/images/image-filters/rick-and-morty-filter-5.webp",
    },
    {
        title: "Comic Art & Illustrations",
        description:
            "Design hilarious cartoon versions of yourself, your friends, or even fictional characters in the same art style as the show. Perfect for memes, posters, or personal projects.",
        image: "/images/image-filters/rick-and-morty-filter-6.webp",
    },
    {
        title: "Creative Storytelling",
        description:
            "Use your Rick and Morty–style characters in storyboards, fan comics, or sci-fi short stories. Bring your imagination to life through animated-style visual storytelling.",
        image: "/images/image-filters/rick-and-morty-filter-7.webp",
    },
];

const RickAndMortyFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/rick-and-morty-filter-1.webp"}
                title={"Turn Yourself into a Rick and Morty Character"}
                description={
                    "Ever wondered what you'd look like if you were drawn into an episode of Rick and Morty? This AI filter transforms your selfies into the show’s wild, exaggerated art style. From spiky hair and portal green hues to cosmic lighting, this filter gives you that unmistakable animated sci-fi look — instantly recognizable and full of attitude."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/rick-and-morty-filter-2.webp"}
                title={"Give Your Friends or Pets a Sci-Fi Cartoon Makeover"}
                description={
                    "Bring your pets or friends into the multiverse! The Rick and Morty Filter creates hilarious, otherworldly cartoon versions of anyone. It’s a fun way to surprise your friends, make memes, or create group avatars that look like they came straight from the show’s universe."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/rick-and-morty-filter-3.webp"}
                title={"Transform Backgrounds into Multiverse Worlds"}
                description={
                    "Turn any environment into a cosmic chaos zone! Whether it's your room, your city, or a vacation spot — the filter reimagines it in Rick and Morty’s interdimensional sci-fi style. Expect glowing portals, alien skies, and surreal details worthy of a new episode."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/rick-and-morty-filter-4.webp"}
                title={"Create Bold Rick and Morty Style Illustrations"}
                description={
                    "Bring the iconic art style to your own creative projects. The filter helps illustrators, content creators, and fans design stylized artwork for posters, digital stories, or profile banners — all with that unique Rick and Morty flair."
                }
            />
            <UseCases
                data={rick_and_morty_use_cases}
                title={
                    "Creative and Pretty Rick and Morty Filters for Everyone"
                }
            />
            <SellFaq data={rick_and_morty_faq_data} />
        </PBox>
    );
};

export default RickAndMortyFilter;
